module.exports = __webpack_public_path__ + "static/media/Inventor CAM.2a6b8d35.png";